import { Button } from "@/components/ui/Button"
import MarketFlag from "@/components/layout/MarketFlag"
import type { Market } from "@/lib/useMarket"

interface Props {
  markets: Market[]
  onPick: (market: Market) => void
}

// Shown when no market is known yet (several markets, none opened this
// session): the same choices as the "Which market?" page.
export default function MarketList({ markets, onPick }: Props) {
  return (
    <div className="flex flex-col gap-3 px-5 py-4">
      <div>
        <h3 className="text-sm font-semibold text-foreground">Which market?</h3>
        <p className="text-sm text-foreground">Pick a market to see this product's stock, plan and prices.</p>
      </div>
      {markets.length === 0 ? (
        <p className="text-sm text-foreground">Your org has no markets yet. Add a country in Org Structure.</p>
      ) : (
        <div className="flex flex-col gap-2">
          {markets.map((m) => (
            <Button
              key={m.id}
              type="button"
              variant="outline"
              onClick={() => onPick(m)}
              className="h-auto justify-start gap-3 px-4 py-3 text-sm font-medium text-foreground"
            >
              <MarketFlag market={m} />
              {m.name}
              <span className="ml-auto text-xs text-muted-foreground">{m.currency}</span>
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}
